type SortOrder = 'asc' | 'desc';

export const sortByDate = <T>(items: T[], dateField: keyof T, order: SortOrder = 'desc'): T[] => {
  return items.sort((a, b) => {
    const dateA = new Date(a[dateField] as unknown as string).getTime();
    const dateB = new Date(b[dateField] as unknown as string).getTime();

    return order === 'asc' ? dateA - dateB : dateB - dateA;
  });
};
